module.exports = __webpack_public_path__ + "img/104956a7a4c2261c8ce07812e415213a.a9dfb9dd.jpg";